import { useId } from "react";

import { TemplateTextArea } from "@/components/AIComponents/ExportablesModal/templates/components/TemplateTextArea";

import { ORGANIZER_DIRECTIONS_MAX_LENGTH } from "./OrganizerDirections.constants";
import {
  directionsLabel,
  textareaCss,
  directionsTextareaCssWrapper,
  paragraphCss,
} from "./OrganizerDirections.styles";

interface OrganizerDirectionsProps {
  name: string;
  value: string;
  viewName?: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  isStudent: boolean;
}

const OrganizerDirections = ({
  name,
  value,
  viewName = name,
  handleChange,
  isStudent,
}: OrganizerDirectionsProps) => {
  const id = useId();
  const formattedName = name.toLowerCase().replace(/\s+/g, "-");
  const qaSelector = `exportables-${formattedName}-directions-input`;

  return (
    <div css={directionsTextareaCssWrapper}>
      <label htmlFor={id} css={directionsLabel}>
        Directions
      </label>
      <TemplateTextArea
        value={value}
        readOnly={isStudent}
        maxLength={ORGANIZER_DIRECTIONS_MAX_LENGTH}
      >
        <TemplateTextArea.TextArea
          id={id}
          data-qa-selector={qaSelector}
          onChange={handleChange}
          aria-label={`${viewName} organizer directions`}
          css={textareaCss}
        />
        <TemplateTextArea.Paragraph css={paragraphCss} />
        <TemplateTextArea.CharacterCount />
      </TemplateTextArea>
    </div>
  );
};

export default OrganizerDirections;
